import { render, staticRenderFns } from "./JcomTableEdit.vue?vue&type=template&id=13008b14"
import script from "./JcomTableEdit.vue?vue&type=script&lang=js"
export * from "./JcomTableEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomTableEdit.vue?vue&type=style&index=0&id=13008b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports